import styled from 'styled-components';

export const TextLabel = styled.h3`
  text-align: left;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.mainFont};
  font-size: 17px;
  font-weight: 800;
  margin: auto 0 16px 0;
`;

export default TextLabel;
